// @json
import mainMenu from './main-menu.json';
import fanSizerSubmenu from './fan-sizer-submenu.json';

// @scripts
import { getRoute } from '../routes';
import { getLinkedApplicationUrl } from '../../helpers/global';
/**
 * @param {Object} text - The current object of texts.
 * @param {{
 *  description: string,
 *  icon: string,
 *  isDefault: boolean,
 *  name: string,
 *  permission: string,
 *  url: string
 * }[]} items
 */
export const getMainMenu = (text, items = mainMenu) => items.map((item) => {
    if (Array.isArray(item.submenuItems)) {
        item.submenuItems = getMainMenu(text, item.submenuItems);
    }

    const route = getRoute(item.name);
    return {
        ...item,
        description: text.routes[item.name],
        isInternal: Boolean(route && !route.application),
        permission: route && route.permission,
        url: route && (route.url || getLinkedApplicationUrl(route.application))
    };
});

/**
 * @param {Object} text - The current object of texts.
 * @param {{
 *  name: string,
 *  permission: string,
 *  title: string,
 *  url: string
 * }[]} items
 */
export const getFanSizerSubmenu = (text, items = fanSizerSubmenu) => items.map((item) => {
    const route = getRoute(item.name);
    return {
        ...item,
        permission: route && route.permission,
        title: text.routes[item.name],
        url: item.url//route && route.url
    };
});
